import NavbarPublico from '../components/NavbarPublico'

function PoliticaPrivacidad() {
  return (
    <div style={estilos.pagina}>
      <NavbarPublico
        onIrALogin={() => { window.location.href = '/?login=1' }}
        onIrARegistro={() => { window.location.href = '/?registro=1' }}
        onIrAInicio={() => { window.location.href = '/' }}
        vistaActiva='legal'
      />
      <div style={estilos.contenido}>
        <h1 style={estilos.titulo}>Política de Privacidad</h1>
        <p style={estilos.fecha}>Última actualización: 13 de abril de 2026</p>

        <h2 style={estilos.h2}>1. Responsable del tratamiento</h2>
        <p style={estilos.texto}>Melina Rivera, titular de ETERN-ME, con domicilio en Madrid, España. Actividad económica en proceso de alta. Contacto: a través del formulario en etern-me.com</p>

        <h2 style={estilos.h2}>2. Datos que recopilamos</h2>
        <ul style={estilos.lista}>
          <li>Nombre completo y email al registrarte</li>
          <li>Información personal que introduces voluntariamente: perfil, suscripciones, cuentas digitales, documentos e instrucciones</li>
          <li>Datos de contacto de herederos y contactos de confianza que añades</li>
          <li>Archivos adjuntos que subes voluntariamente (fotos, PDFs, documentos)</li>
          <li>Datos de navegación técnicos (cookies estrictamente necesarias)</li>
        </ul>

        <h2 style={estilos.h2}>3. Finalidad del tratamiento</h2>
        <ul style={estilos.lista}>
          <li>Prestación del servicio de organización y gestión de información personal y legado digital</li>
          <li>Comunicaciones del servicio: alertas del sistema de seguridad, notificaciones a contactos de confianza</li>
          <li>Entrega de mensajes póstumos y cápsulas del tiempo a los destinatarios designados</li>
          <li>Atención al cliente</li>
        </ul>

        <h2 style={estilos.h2}>4. Base legal</h2>
        <p style={estilos.texto}>Ejecución del contrato de servicio aceptado al registrarte (art. 6.1.b RGPD) y tu consentimiento explícito para el tratamiento de datos sensibles que introduces voluntariamente (art. 6.1.a RGPD).</p>

        <h2 style={estilos.h2}>5. Conservación de datos</h2>
        <p style={estilos.texto}>Conservamos tus datos mientras tengas cuenta activa. Si eliminas tu cuenta, todos tus datos personales, archivos y la información de tus herederos se eliminan permanentemente de nuestros servidores en un plazo máximo de 30 días, conforme al artículo 17 del RGPD (derecho al olvido).</p>

        <h2 style={estilos.h2}>6. Destinatarios</h2>
        <ul style={estilos.lista}>
          <li>Supabase Inc. — base de datos, autenticación y almacenamiento de archivos (servidores en la UE)</li>
          <li>Vercel Inc. — alojamiento web del frontend</li>
          <li>Railway Corp. — servidor backend</li>
          <li>Resend Inc. — envío de emails transaccionales</li>
          <li>Los herederos y contactos de confianza que tú mismo designes</li>
        </ul>
        <p style={estilos.texto}>No vendemos ni cedemos tus datos a terceros con fines comerciales. Nunca.</p>

        <h2 style={estilos.h2}>7. Transferencias internacionales</h2>
        <p style={estilos.texto}>Algunos proveedores técnicos tienen sede fuera de la UE. En todos los casos, las transferencias se realizan bajo las garantías adecuadas del RGPD: cláusulas contractuales tipo o decisiones de adecuación de la Comisión Europea.</p>

        <h2 style={estilos.h2}>8. Tus derechos</h2>
        <p style={estilos.texto}>Conforme al RGPD y la LOPDGDD, tienes derecho a acceder, rectificar, eliminar, oponerte, limitar el tratamiento y portar tus datos. Puedes ejercer estos derechos directamente desde tu cuenta en etern-me.com (sección "Mi perfil → Eliminar cuenta") o contactando a través del formulario de la web. Si consideras que tus derechos no han sido atendidos, puedes reclamar ante la Agencia Española de Protección de Datos (aepd.es).</p>

        <h2 style={estilos.h2}>9. Derecho al olvido y eliminación de cuenta</h2>
        <p style={estilos.texto}>Puedes eliminar tu cuenta y todos tus datos en cualquier momento desde "Mi perfil → Cuenta y privacidad → Eliminar cuenta". Esta acción es irreversible y elimina permanentemente toda tu información de nuestros servidores en un plazo máximo de 30 días.</p>

        <h2 style={estilos.h2}>10. Legado digital y datos de personas fallecidas</h2>
        <p style={estilos.texto}>De conformidad con el artículo 3 de la Ley Orgánica 3/2018 (LOPDGDD), las personas vinculadas al usuario por razones familiares o de hecho podrán acceder a los datos del titular fallecido en los términos que el propio usuario haya configurado en la plataforma. El usuario tiene control total sobre quién puede acceder a su información y en qué condiciones.</p>

        <h2 style={estilos.h2}>11. Seguridad</h2>
        <p style={estilos.texto}>Implementamos cifrado en tránsito (TLS) y en reposo, autenticación segura mediante Supabase Auth, acceso restringido por roles y niveles definidos por el propio usuario. El acceso a tus datos siempre requiere autorización explícita tuya.</p>

        <h2 style={estilos.h2}>12. Cookies</h2>
        <p style={estilos.texto}>Utilizamos únicamente cookies técnicas estrictamente necesarias para el funcionamiento del servicio. No utilizamos cookies de seguimiento, publicidad ni analítica de terceros.</p>
      </div>
      <footer style={estilos.footer}>
        <div style={estilos.footerContenido}>
          <p style={estilos.footerCopy}>2026 ETERN-ME · Todos los derechos reservados · Creado por Melina Rivera</p>
          <div style={estilos.footerLinks}>
            <a href="/privacidad" style={estilos.footerLink}>Privacidad</a>
            <a href="/terminos" style={estilos.footerLink}>Términos</a>
            <a href="/aviso-legal" style={estilos.footerLink}>Aviso Legal</a>
          </div>
        </div>
      </footer>
    </div>
  )
}

const estilos = {
  pagina: { minHeight: '100vh', backgroundColor: '#FAF8F5', display: 'flex', flexDirection: 'column' },
  contenido: { maxWidth: '760px', margin: '0 auto', padding: '48px 24px', flex: 1 },
  titulo: { fontSize: '32px', fontWeight: '800', color: '#2C1810', marginBottom: '8px', letterSpacing: '-0.5px' },
  fecha: { fontSize: '13px', color: '#8B6F47', marginBottom: '40px' },
  h2: { fontSize: '18px', fontWeight: '700', color: '#2C1810', marginTop: '32px', marginBottom: '12px' },
  texto: { fontSize: '15px', color: '#5C4033', lineHeight: '1.8', marginBottom: '12px' },
  lista: { fontSize: '15px', color: '#5C4033', lineHeight: '1.8', paddingLeft: '24px', marginBottom: '12px' },
  footer: { backgroundColor: '#2C1810', padding: '24px 32px' },
  footerContenido: { maxWidth: '1100px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' },
  footerCopy: { color: '#ac9370', fontSize: '13px' },
  footerLinks: { display: 'flex', gap: '20px' },
  footerLink: { color: '#C4A882', fontSize: '13px', textDecoration: 'none' },
}

export default PoliticaPrivacidad